<template>
  <div>
    <router-view />
    <!--  -->
    <!--  -->
  </div>
</template>

<script>
import { WindowUtil } from "@/shared/utils";
import { AccountUtil } from "@/shared/vuex";
import { Options, Vue } from "vue-class-component";

@Options({
  title: "Equity4Talent Admin",
  components: {},
})
export default class extends Vue {
  /**
   * @user info
   */
  get user() {
    return this.$store.state.account.user;
  }
  /**
   *
   */
  mounted() {
    WindowUtil.listenToChange(document, this.$store);
  }
}
</script>

<style lang="scss">
@import "./styles.scss";
</style>
